import { ApprovalableTypeEnum } from 'api-hooks/common';
import { getRefundsKey, useCreateRefund } from 'api-hooks/refund/refund';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useDialog from 'hooks/use-dialog';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import RequestApprovalModal from 'legacy-modules/approval/approval/components/request-modal';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import RefundForm, { SaleInvoiceRefundType } from './components/form';

export type RefundCreateParams = {
  invoice?: SaleInvoiceRefundType;
};

export default function RefundCreate(
  props: NavigationProps<NavigationRoutes.RefundCreate>,
) {
  const { navigate } = useNavigation();

  const { mutateAsync, error } = useCreateRefund();
  const dialog = useDialog();
  const permission = useGetCrudPermission('refunds');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <RefundForm
        {...props}
        saleInvoice={props.navigation?.params?.invoice}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          const onHandle = () => {
            queryClient.refetchQueries([getRefundsKey()[0]]);

            if (permission.view) {
              navigate(NavigationRoutes.RefundView, {
                id: result.data?.id,
              });
            }
          };

          if (
            input.releasePurchase &&
            input.releaseSale.amount > input.releasePurchase.amount
          ) {
            dialog.showCustom({
              render: (dismiss) => (
                <RequestApprovalModal
                  onClose={() => {
                    dismiss();
                    onHandle();
                  }}
                  data={{
                    approvalableId: result.data.id,
                    approvalableType: ApprovalableTypeEnum.Refund,
                  }}
                  onDismissSuccess={onHandle}
                />
              ),
            });
          } else {
            onHandle();
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
